// Derived texts for recipes, as in the Android models (RecipeSummary, IngredientLine, CatalogItem).
import * as T from '../types';
import { frequencyText, leadTime, quantity, sectionText, unitShort } from '../labels';

const COURSE_PREFIX: Partial<Record<T.RecipeCourse, string>> = { Side: 'Acompanhamento', Starter: 'Entrada', Dessert: 'Sobremesa' };

/** "Acompanhamento · Habitual · 30 min · rápida · dá sobras · 5 ingredientes". */
export function recipeSubtitle(r: T.RecipeSummary): string {
  const parts = [frequencyText(r.frequency)];
  const course = COURSE_PREFIX[r.course];
  if (course) parts.unshift(course);
  if (r.prepMinutes !== null && r.prepMinutes !== undefined) parts.push(`${r.prepMinutes} min`);
  if (r.isQuick) parts.push('rápida');
  if (r.yieldsLeftovers) parts.push('dá sobras');
  parts.push(r.ingredientCount === 1 ? '1 ingrediente' : `${r.ingredientCount} ingredientes`);
  return parts.join(' · ');
}

/** "Mercearia · kg · despensa · 3 receitas". */
export function catalogSubtitle(item: T.CatalogItem): string {
  const parts = [sectionText(item.storeSection), unitShort(item.defaultUnit)];
  if (item.kind === 'Household') parts.unshift('Casa');
  if (item.isPantryStaple) parts.push('despensa');
  if (item.recipeCount > 0) parts.push(item.recipeCount === 1 ? '1 receita' : `${item.recipeCount} receitas`);
  return parts.join(' · ');
}

/** An ingredient line while editing a recipe; the item is either existing or to be created. */
export interface IngredientLine {
  key: string;
  catalogItemPublicId?: T.Guid | null;
  name: string;
  newItemSection?: T.StoreSection | null;
  quantity?: number | null;
  unit?: T.MeasureUnit | null;
  note?: string | null;
}

/** "Cebola — 2 un · picada". */
export function ingredientDetail(line: IngredientLine): string {
  return [quantity(line.quantity, line.unit), line.note ?? ''].filter(s => s.trim().length > 0).join(' · ');
}

export const prepStepText = (step: T.RecipePrepStep) => `${step.title} · ${leadTime(step.leadTimeMinutes)}`;

export function toIngredientRequest(line: IngredientLine): T.SaveRecipeIngredientRequest {
  return line.catalogItemPublicId
    ? { catalogItemPublicId: line.catalogItemPublicId, quantity: line.quantity ?? null, unit: line.unit ?? null, note: line.note ?? null }
    : { newItemName: line.name, newItemSection: line.newItemSection ?? 'Other', quantity: line.quantity ?? null, unit: line.unit ?? null, note: line.note ?? null };
}
